// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_ce-0";
export var headerCellHover = "_ce-1";